// extracted by mini-css-extract-plugin
export default {"container":"tours_container__yZIRC","item":"tours_item__2uIhs"};